<div class="upload-wrapper row">
  <div class="col-lg-12">
    <div
      draggable="true"
      class="upload-container"
      ngClass="{{ dragAreaClass }}"
    >
      <div class="border-container">
        <p>
          Drag & Drop files here Or
        </p>
        <p class="click-to-browse">
          <a
            href="javascript:void(0)"
            (click)="file.click()"
            id="file-browser"
            >Click to browse</a
          >
        </p>
        <div class="file-support-type">
          <ng-container [ngSwitch]="getPage">
            <ng-container *ngSwitchCase="'photos-upload'">
              Supported File Types: JPG,
              JPEG, GIF, PNG, BMP
            </ng-container>
            <ng-container *ngSwitchCase="'videos-upload'">
              Supported File Types: AVI,
              MPG, WMV, MP4, MOV, FLV, MKV, VOB, WEBM, ASF, MTS, TS
            </ng-container>
            <ng-container *ngSwitchCase="'upload-prototype'">
              Supported File Types: AVI,
              MPG, WMV, MP4, MOV, FLV, MKV, VOB, WEBM, ASF, MTS, TS
            </ng-container>
            <ng-container *ngSwitchCase="'audios-upload'">
              Supported File Types: AAC,
              MP3, WAV, WMA
            </ng-container>
            <ng-container *ngSwitchCase="'documents-upload'">
              Supported File Types: DOC,
              DOCX, XLS, XLSX, PPT, PPTX, PDF, RTF, TXT
            </ng-container>
            <ng-container *ngSwitchCase="'allfiles-upload'">
              Supported File Types: AAC,
              MP3, WAV, WMA, DOC, DOCX, XLS, XLSX, PPT, PPTX, PDF, RTF, TXT,
              JPG, JPEG, GIF, PNG, BMP, AVI, MPG, WMV, MP4, MOV, FLV, MKV, VOB,
              WEBM, ASF, MTS, TS
            </ng-container>
            <ng-container *ngSwitchDefault>
              Supported File Types: AAC,
              MP3, WAV, WMA, DOC, DOCX, XLS, XLSX, PPT, PPTX, PDF, RTF, TXT,
              JPG, JPEG, GIF, PNG, BMP, AVI, MPG, WMV, MP4, MOV, FLV, MKV, VOB,
              WEBM, ASF, MTS, TS
            </ng-container>
          </ng-container>
        </div>

        <input
          type="file"
          #file
          multiple
          style="display: none"
          (change)="onFileChange($event)"
        />
      </div>
    </div>
  </div>
</div>

<div class="upload-description row" *ngIf="selectedFiles.length > 0">
  <div class="col-lg-12">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Size</th>
          <th>Last Modified Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of selectedFiles; let i = index">
          <td>
            {{ file.name }}
          </td>
          <td>
            {{ formatBytes(file?.size) }}
          </td>
          <td>
            {{ file.lastModifiedDate | date : "MMM-d-YYYY HH:mm:ss" }}
          </td>
          <td>
            <button
              nbButton
              matRipple
              status="info"
              hero
              title="Remove"
              (click)="remove(file)"
            >
              <i class="fal fa-times"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="buttons-row">
    <div class="col-lg-6 col-md-6 col-sm-6 left-side">
      <button nbButton matRipple status="info" hero (click)="upload()">
        Upload
      </button>
      <button nbButton matRipple status="info" hero (click)="cancel()">
        Cancel
      </button>
      <button nbButton matRipple status="info" hero (click)="removeAll()">
        Remove All
      </button>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 right-side">
      <p>
        Total Size of Upload
        {{ formatBytes(totalFilesSize) }}
      </p>
    </div>
  </div>
</div>

<!-- <ngx-upload-download-progress
  [title]="'Please wait while files are being uploaded…'"
  *ngIf="isExecuting"
></ngx-upload-download-progress> -->

<div class="overlay" *ngIf="isExecuting">
  <div
    class="d-flex align-items-center justify-content-center waiting-upload-overlay"
  >
    <div class="waiting-upload-message">
      <div class="row">
        <div class="col-md-12">
          <span class="loading-text">Please wait while files are being uploaded…</span>
        </div>
        <div class="col-md-12 nopadding-right">
          <div class="waiting-upload-progress">
            <div class="progress">
              <div
                id="waiting-upload-div-progress"
                class="progress-bar active"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: 0%"
              ></div>
            </div>
          </div>
          <div
            class="waiting-upload-textprogress"
            style="display: inline-block"
          >
            <span id="waiting-upload-div-spanprogress" class="loading-text"
              >0 %</span
            >
            <input type="hidden" id="waiting-upload-div-inputprogress" />
          </div>
        </div>
        <div class="col-md-12">
          <span class="loading-text-complete">It may take several minutes to complete.</span>
          <span class="loading-text-donotRefresh">DO NOT refresh the page or close the page.</span>
        </div>
      </div>
    </div>
  </div>
</div>
